<template>
    <span class="co2"> 
        <span class="title">CO₂</span>
        <span class="value">
          <template v-if="this.etat == false" title="test">
           <span title="Cette valeur correspond à l'économie réalisée par tous les utilisateurs ayant utilisé l'éco-mode"> {{ this.current_data.site.kg }} kg </span>
          </template>
          <template v-else>
            <span title="Cette valeur correspond à l'économie réalisée par votre session sur notre site internet">{{ this.current_data.utilisateur.gramme }} g</span>
          </template>
        </span>
    </span>
</template>
<script>
export default {
  name: 'PanelCo2',
  props: ['current_data', 'etat'],
  data () {
    return {
      current:null
    }
  }
}
</script>
<style scoped>
    .co2 {
        flex-direction: column;
        text-align: center;
        font-size:0.9rem;
        margin:10px auto 10px auto;
        line-height: 1;
        color: #b8e994;
        cursor: pointer;
    }
    .co2 .title {
        display: block;
        width: 100%; 
    }
    .co2 .value {
        font-weight: bold;
    }
    @media screen and (max-width:500px) {
      .co2 {
        display: none;
      }
    }
</style>